// Generated by purs version 0.13.8
"use strict";
var Data_FunctorWithIndex = require("../Data.FunctorWithIndex/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var indexed = function (dictFunctorWithIndex) {
    return Data_FunctorWithIndex.mapWithIndex(dictFunctorWithIndex)(Data_Tuple.Tuple.create);
};
module.exports = {
    indexed: indexed
};
